const fixtures = {
  s_id: null,
  questions: [],
  response_type: 'survey',
  lang: 'en',
};

export default fixtures;
